const cultureSwitcherFlag = import.meta.env.NX_CULTURE_SWITCHER_FLAG

export const isCultureSwitcherFlagEnabled = (): boolean => {
  return cultureSwitcherFlag === 'true'
}
